// Map style metadata (matching AdminStyle.tsx)
export type MapStyleMeta = {
	id: string;
	label: string;
	isPro?: boolean;
	image: string;
	mapboxUrl: string;
};

export const MAP_STYLES: MapStyleMeta[] = [
	// Stippl always first, then remaining non-pro a-z
	{
		id: "stippl",
		label: "Stippl",
		image: "/maps/stipplMap.png",
		mapboxUrl: "mapbox://styles/omars/clgar7r6s000401pjx0hrkkeg",
	},
	{
		id: "satellite",
		label: "Satellite",
		image: "/maps/satelliteMap.png",
		mapboxUrl: "mapbox://styles/omars/clwhlj2cv00og01qs8qul5c1h",
	},
	// Pro, a-z
	{
		id: "adventure",
		label: "Adventure",
		image: "/maps/adventureMap.png",
		mapboxUrl: "mapbox://styles/omars/clwhqsghm00p401qs12wu0zh0",
		isPro: true,
	},
	{
		id: "alabaster",
		label: "Alabaster",
		image: "/maps/alabasterMap.png",
		mapboxUrl: "mapbox://styles/omars/clwho64rp002l01po996774se",
		isPro: true,
	},
	{
		id: "city",
		label: "City",
		image: "/maps/cityMap.png",
		mapboxUrl: "mapbox://styles/omars/clwhrd6a100pc01qr5xntd2lu",
		isPro: true,
	},
	{
		id: "espionage",
		label: "Espionage",
		image: "/maps/espionageMap.png",
		mapboxUrl: "mapbox://styles/omars/clwhnk34300fd01qx3x5ictls",
		isPro: true,
	},
	{
		id: "nocturne",
		label: "Nocturne",
		image: "/maps/nocturneMap.png",
		mapboxUrl: "mapbox://styles/omars/clwhms5d500kn01pnfpdr12x8",
		isPro: true,
	},
	{
		id: "obsidian",
		label: "Obsidian",
		image: "/maps/obsidianMap.png",
		mapboxUrl: "mapbox://styles/omars/clwhnok4x00p301qr4r039ns6",
		isPro: true,
	},
	{
		id: "polaris",
		label: "Polaris",
		image: "/maps/polarisMap.png",
		mapboxUrl: "mapbox://styles/omars/clwhr4h4u00l201pn9ek40522",
		isPro: true,
	},
	{
		id: "unicorn",
		label: "Unicorn",
		image: "/maps/unicornMap.png",
		mapboxUrl: "mapbox://styles/omars/clwhnhfl000l801ny8qzrblba",
		isPro: true,
	},
];

// Map style preview images (for simple lookups)
export const MAP_STYLE_IMAGES: Record<string, string> = Object.fromEntries(
	MAP_STYLES.map((style) => [style.id, style.image])
);

// Map style key -> Mapbox URL (for rendering maps)
export const MAP_STYLE_URLS: Record<string, string> = Object.fromEntries(
	MAP_STYLES.map((style) => [style.id, style.mapboxUrl])
);

// Reverse mapping: Mapbox URL -> style key (for display)
export const MAPBOX_URL_TO_STYLE: Record<string, string> = Object.fromEntries(
	MAP_STYLES.map((style) => [style.mapboxUrl, style.id])
);

// Mapbox URL -> friendly label (for display in chips/labels)
export const MAPBOX_URL_TO_LABEL: Record<string, string> = Object.fromEntries(
	MAP_STYLES.map((style) => [style.mapboxUrl, style.label])
);
